import axios from "axios";
import { Api } from "src/api/generated";

export const appURL = process.env.REACT_APP_API_URL;

// Обвязка над сгенерированным клиентом (src/api/generated.ts — артефакт
// `npm run apigen`, руками не редактируется). Токены живут в localStorage,
// как и в рукописном клиенте src/api/api.ts (см. AuthContext).
const api = new Api({
  baseURL: appURL,
  timeout: 20000,
  secure: true, // применять securityWorker к запросам, помеченным secure в swagger
  securityWorker: () => {
    const token = localStorage.getItem("accessToken");
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  },
});

// Клиент без авторизации для публичных эндпоинтов (login, refresh)
export const apiNoAuth = new Api({ baseURL: appURL, timeout: 20000 });

// api.instance — обычный axios-инстанс, на него вешаются интерцепторы
api.instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (error?.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        const { data } = await axios.post(`${appURL}refresh`, { refreshToken });

        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);

        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;

        return api.instance(originalRequest);
      }
    }

    if (error?.response?.status === 403 || error?.response?.status === 400) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    }

    return Promise.reject(error);
  },
);

export default api;
